import reportLocales from 'globals/locales/report';

const {
  income: incomeCaption,
  expenditure: expenditureCaption,
  balance: balanceCaption,
  id: idLabel,
  maturity: maturityLabel,
  opening: openingLabel,
} = reportLocales.account.accountDetailsSection;

export interface GetDetailsProps {
  id: string;
  maturity: string;
  opening: string;
}

export interface SingleAccountPickerDetailsInfo {
  label: string;
  value: string;
}

export const getDetails = ({
  id,
  maturity,
  opening,
}: GetDetailsProps): SingleAccountPickerDetailsInfo[] => {
  return [
    {
      label: idLabel,
      value: id,
    },
    {
      label: maturityLabel,
      value: maturity,
    },
    {
      label: openingLabel,
      value: opening,
    },
  ];
};

export interface GetValuesProps {
  income: string;
  expenditure: string;
  balance: string;
}

export interface SingleAccountPickerValue {
  caption: string;
  value: string;
}

export const getValues = ({
  income,
  expenditure,
  balance,
}: GetValuesProps): SingleAccountPickerValue[] => {
  return [
    {
      caption: incomeCaption,
      value: income,
    },
    {
      caption: expenditureCaption,
      value: expenditure,
    },
    {
      caption: balanceCaption,
      value: balance,
    },
  ];
};
